import { useState, useEffect } from "react";
import _ from "lodash";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { Box, Collapse, Fade, Grid2, Link, Stack, Typography, useTheme } from "@mui/material";
import { EGInput } from "../../../../MainComponents/Input/EGInput";
import { Radios } from "../../../../MainComponents/Radios/Radios";
import { InvestigationButton } from "../components";
import { returnIsValid } from "../Main/useConstants";
import { InputCatalogue } from "../../../../MainComponents/Catalogues/InputCatalogue";

// Funcion revisar el formulario y retornar si es valido y cuales son los errores
const validateForm = (form) => {
  const { inside, location, center } = form;
  console.log(center)
  const errors = {};
  if (inside == null) {
    errors.inside = true;
  } else {
    if (!inside && location.trim() === "") {
      errors.location = true;
    }
    if (inside && center.trim() === "") {
      errors.center = true;
    }
  }
  return [
    Object.entries(errors).length === 0 ? true : false,
    errors
  ];
}

const REVEAL_MS = 220;

// Entrada de un campo: siempre aparece con un fundido y, con `grow`, ademas abre
// su espacio para no empujar de golpe lo que tiene debajo.
const RevealField = ({ grow = true, size = { xs: 12, lg: 6 }, children }) => (
  <Fade in timeout={REVEAL_MS}>
    <Grid2 size={size}>
      <Collapse in appear={grow} timeout={REVEAL_MS}>
        {children}
      </Collapse>
    </Grid2>
  </Fade>
);

// El primer nivel toma el lugar del campo que reemplaza; solo los niveles
// anidados necesitan abrir espacio.
const CatalogueLevel = ({ level, children }) => (
  <RevealField grow={level > 0}>{children}</RevealField>
);

export const AddAndEditScenario = ({ scenarios, selectedScenario, setSelectedScenario, setIsEditing, handleSaveScenarios }) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();
  const [inside, setInside] = useState(null);
  const [location, setLocation] = useState("");
  const [details, setDetails] = useState("");
  const [area, setArea] = useState("");
  const [center, setCenter] = useState("");
  const [activeDetails, setActiveDetails] = useState(false);
  const [triedToSave, setTriedToSave] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedScenario != null) {
      const currentScenario = scenarios[selectedScenario];
      setInside(currentScenario.inside ?? null);
      setLocation(currentScenario.location ?? "");
      setCenter(currentScenario.center ?? "");
      setDetails(currentScenario.details ?? "");
      setArea(currentScenario.area ?? "");
      setActiveDetails(!!(currentScenario.details || currentScenario.area));
    }
  }, [selectedScenario]);

  useEffect(() => {
    if (triedToSave) {
      const [_, errors] = validateForm({ inside, location, center });
      setErrors(errors);
    }
  }, [inside, location, center]);

  const handleChangeInside = (value) => {
    if (value === "false") setInside(false);
    if (value === "true") setInside(true);
    // setErrors({});
    // setTriedToSave(false);
  }

  const handleClose = () => {
    setSelectedScenario(null);
    setIsEditing(false);
  }

  const handleSave = async () => {
    const newCenter = inside ? center : "";
    const newLocation = !inside ? location : "";
    const newArea = inside ? area : "";

    const scenario = {
      inside,
      location: newLocation,
      details,
      center: newCenter,
      area: newArea,
      ...(inside && { catalogue: "business_units" }),
    };

    const [isValid, errors] = validateForm(scenario);
    setErrors(errors);
    setTriedToSave(true);
    if (!isValid) {
      enqueueSnackbar({ variant: "error", message: t("missing_required_inputs") });
      return;
    };

    if (selectedScenario != null) {
      const newScenarios = _.cloneDeep(scenarios);
      newScenarios[selectedScenario] = scenario;
      await handleSaveScenarios(newScenarios);
    } else {
      await handleSaveScenarios([...scenarios, scenario]);
    }
    handleClose();
  }

  const eventsPlaceOptions = [
    {
      value: true,
      label: t("locations.location_inside_the_work_center_check"),
    },
    {
      value: false,
      label: t("locations.location_outside_the_work_center_check"),
    },
  ]

  return (
    <>
      <Box padding={2}>
        <Box display="flex" alignItems="center" marginBottom={1.5}>
          <Typography
            fontWeight={600}
            fontSize={16}
            color={theme.palette.ethicsBlue.main}
          >
            {selectedScenario != null ? t("locations.edit_location") : t("locations.add_new_location")}
          </Typography>
          <Box
            flexGrow={1}
            height="1px"
            sx={{
              backgroundColor: theme.palette.ethicsBlue.main,
              marginLeft: 1
            }}
          />
        </Box>

        <Radios
          value={inside}
          onChangue={handleChangeInside}
          text={t("locations.where_happened_the_facts")}
          required={true}
          helpText={t("locations.help_text")}
          options={eventsPlaceOptions}
          isValid={returnIsValid(errors?.inside, triedToSave) ?? null}
          showSuccessValidation={true}
          row
        />

        <Collapse in={inside != null} timeout={REVEAL_MS}>
          <Grid2 container spacing={2} sx={{ pt: 2 }}>
            {
              inside === false &&
              <RevealField grow={false}>
                <EGInput
                  label={t("locations.location")}
                  value={location}
                  name="location"
                  onChange={(e) => setLocation(e.target.value)}
                  required={true}
                  isValid={returnIsValid(errors?.location, triedToSave) ?? null}
                  showSuccessValidation
                  showHelpText={false}
                />
              </RevealField>
            }

            {
              inside === true &&
              <InputCatalogue
                label={t("locations.work_center")}
                defaultValue={center}
                catalogue={"business_units"}
                isOwn={true}
                showWhenEmpty
                labelFromSelection
                onChange={setCenter}
                isValid={returnIsValid(errors?.center, triedToSave) ?? null}
                wrapper={CatalogueLevel}
              />
            }

            {/* El area solo se guarda para ubicaciones dentro de un centro. */}
            {
              inside === true && activeDetails &&
              <RevealField>
                <EGInput
                  label={t("locations.area")}
                  value={area}
                  onChange={(e) => setArea(e.target.value)}
                />
              </RevealField>
            }

            {
              activeDetails ? (
                <RevealField size={12}>
                  <EGInput
                    label={t("locations.details")}
                    value={details}
                    onChange={(e) => setDetails(e.target.value)}
                    type="textarea"
                    multiline
                    rows={5}
                  />
                </RevealField>
              ) : (
                <Grid2 size={12} sx={{ textAlign: "end" }}>
                  <Link onClick={() => setActiveDetails(true)} underline="hover">
                    + {t("locations.add_details")}
                  </Link>
                </Grid2>
              )
            }
          </Grid2>
        </Collapse>

        <Stack direction={{ xs: "column", md: "row" }} justifyContent="flex-end" spacing={1} sx={{ mt: 2 }}>
          <InvestigationButton
            label={t("locations.cancel")}
            icon="close_icon"
            size="medium"
            onClick={handleClose}
          />
          <InvestigationButton
            label={t("locations.save")}
            variant="success"
            size="medium"
            icon="mark_check_bold"
            onClick={handleSave}
          />
        </Stack>
      </Box>
    </>
  )
}